import { render, staticRenderFns } from "./CompanyMessageList.vue?vue&type=template&id=6d4e538a"
import script from "./CompanyMessageList.vue?vue&type=script&lang=js"
export * from "./CompanyMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4e538a')) {
      api.createRecord('6d4e538a', component.options)
    } else {
      api.reload('6d4e538a', component.options)
    }
    module.hot.accept("./CompanyMessageList.vue?vue&type=template&id=6d4e538a", function () {
      api.rerender('6d4e538a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/companymessage/CompanyMessageList.vue"
export default component.exports